// extracted by mini-css-extract-plugin
export default {"accountBenefitsContainer":"AccountBenefits-module__accountBenefitsContainer___jLJ5C"};